var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"1.5.5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/n/p";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as SentryBrowser from "@sentry/browser";
import * as SentryIntegration from "@sentry/integrations";
import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://1b71bcb3ae4a4989be904fd24d0564af@o1163218.ingest.sentry.io/6707111",
  enabled: ["production", "staging"].includes(global.ENVIRONMENT),
  replaysOnErrorSampleRate: 0.1,
  environment: global.ENVIRONMENT,
  // Adjust this value in production, or use tracesSampler for greater control
  // We already send traces to Datadog; no need for Sentry to collect them too.
  tracesSampleRate: 0,
  release: process.env.CONTAINER_TAG,
  beforeBreadcrumb: (breadcrumb, hint) => {
    if (breadcrumb.category !== "fetch") {
      return breadcrumb;
    }
    try {
      const [, options] = hint.input;
      breadcrumb.data = {
        ...breadcrumb.data,
        body: options?.body,
      };
    } finally {
      return breadcrumb;
    }
  },
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    SentryIntegration.rewriteFramesIntegration({
      iteratee: frame => {
        frame.filename = frame.filename.replace(
          "https://assets.sonder.com/n/p/",
          "/",
        );
        // Ensure the filename is decoded as it is always reported as percent encoded
        frame.filename = decodeURIComponent(frame.filename);
        return frame;
      },
    }),
    SentryBrowser.httpClientIntegration(),
  ],
});
